module.exports = __webpack_public_path__ + "e1f6f1ac4028ae4dae3c7444c59e7921.svg";